module.exports = __webpack_public_path__ + "img/spotcam.8e121c4f.png";